import styled from "styled-components";

export const JackpotBetWidgetGradientTextDefaultBox = styled.div<{fontSize?: string; dontUpperCase?: boolean}>`
  font-size: ${props => props.fontSize ? props.fontSize : "2rem"};
  transition: opacity 0.25s ease-in, transform 0.25s ease-in;
  line-height: 24px;
  font-weight: bold;
  
  text-shadow: 0 2px 5px #00000040;
  background: linear-gradient(180deg, #FCE403 0%, #7FF800 100%);
  
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  
  clip-path: inset(1px);
`;
